<script>
export default {
  name: 'GlMarkdown',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="md" v-html="$sanitize(text)"></div>
</template>
